import { DateTime } from 'luxon';
export const formatTime = (isoDate, options) => {
    let parsed = DateTime.fromISO(isoDate);
    if (!parsed.isValid) {
        parsed = DateTime.fromJSDate(isoDate);
    }
    if (!parsed.isValid) {
        throw new Error('Date is not specified');
    }
    if (options === null || options === void 0 ? void 0 : options.timezone) {
        parsed = parsed.setZone(options.timezone);
    }
    const formatOptions = (options === null || options === void 0 ? void 0 : options.formatOptions) ? options.formatOptions : {};
    return parsed.toLocaleString(formatOptions);
};
//# sourceMappingURL=formatTime.js.map